/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react'
import {useSelector} from 'react-redux'
import {isEmpty, isLoaded} from 'react-redux-firebase'
import {Redirect, Route} from 'react-router-dom'
import {routes} from '../../utils/config'
import {GameHeader} from '../../components/app'

const PrivateRoute = ({component: Component, header = true, ...rest}) => {
  const auth = useSelector(state => state.firebase.auth)
  const user = useSelector(state => state.firestore?.data?.user)

  // redirect to login if not authenticated
  if (isEmpty(auth)) {
    return (
      <Route
        {...rest}
        render={props => (
          <Redirect to={{pathname: routes.login.url, state: {from: props.location}}} />
        )}
      />
    )
  }

  // redirect to on-boarding if not set-up, (or home if on-boarding complete)
  // const isSetup = enrollments && enrollments.every(obj => obj.studentName === 'Fred')
  const isSetup = isLoaded(user) && user.onboardingComplete

  if (isSetup && rest.path === routes.onboarding.url) {
    return (
      <Route
        {...rest}
        render={props => (
          <Redirect to={{pathname: routes.roleSelector.url, state: {from: props.location}}} />
        )}
      />
    )
  } else if (!isSetup && rest.path !== routes.onboarding.url) {
    return (
      <Route
        {...rest}
        render={props => (
          <Redirect to={{pathname: routes.onboarding.url, state: {from: props.location}}} />
        )}
      />
    )
  }

  // otherwise, whatever they desire
  return (
    <>
      {header ? <GameHeader /> : ''}
      <Route {...rest} render={props => <Component {...props} />} />
    </>
  )
}

export default PrivateRoute
